import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import SiteOperating from "@/components/SiteOperating";
import { Clock } from "lucide-react";

export default function OperatingHours() {
  const { has } = useAuth();
  const [venues, setVenues] = useState([]);
  const [vid, setVid] = useState("");

  useEffect(() => {
    api.get("/venues").then((r) => { setVenues(r.data); if (r.data[0]) setVid(r.data[0].venue_id); }).catch(() => {});
  }, []);

  const canManage = has("manage_site_operating_status");

  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="operating-hours-page">
      <div className="flex items-center gap-2">
        <Clock className="text-brand" size={22} />
        <h1 className="font-display text-2xl font-bold text-slate-800">Opening Hours & Closures</h1>
      </div>
      <p className="text-sm text-slate-500">Set when each of your sites operates so CaterCTRL only expects compliance on open days.</p>
      {venues.length === 0 ? (
        <div className="cc-card p-8 text-center text-slate-400" data-testid="operating-no-sites">No sites available for your account.</div>
      ) : (
        <>
          <div className="cc-card p-4">
            <label className="text-xs font-semibold text-slate-600">Site</label>
            <select value={vid} onChange={(e) => setVid(e.target.value)} data-testid="operating-page-venue-select"
              className="mt-1.5 w-full border border-slate-200 rounded-lg px-3 py-2 text-sm">
              {venues.map((v) => <option key={v.venue_id} value={v.venue_id}>{v.name}</option>)}
            </select>
          </div>
          {vid && <SiteOperating venueId={vid} canManageSchedule={canManage} canManageClosures={canManage} />}
        </>
      )}
    </div>
  );
}
